/**
 * @file  页面底部Footer部分
 * 
 * @author Guojun Wang
 * @date   2022-12-14 09:12:29
 * **/ 

import React from 'react';
import './less/antMotionStyle.less';

class Footer extends React.Component {
  static defaultProps = {
    className: 'footer1',
  };

  render() {
    return (
      <div className="common-footer">
        <div className="common-flex">
        <div className="common-footer-logo">
          <img src="/assets/images/footer-labicon.png" alt="LOGO" />
          <div className='common-link' onClick={()=>{
           window.open('https://beian.miit.gov.cn/#/Integrated/recordQuery', '_blank');
        }}>浙ICP备2022011639号</div>
        <div className='common-link' onClick={()=>{
           window.open('https://beian.mps.gov.cn/#/query/webSearch', '_blank');
        }}>浙公网安备33010602012916号</div>
          <p style={{display:'flex',flexDirection:'row'}}>Copyright ©2024 <div className='common-link-lab' style={{margin:'0 6px'}}onClick={()=>{
           window.open('https://www.wllsb.edu.cn/', '_blank');
        }}>Westlake Laboratory</div> and <div className='common-link-lab' style={{marginLeft:6}} onClick={()=>{
          window.open('https://yanglab.westlake.edu.cn/', '_blank');
       }}>Yang Lab</div>. All Rights Reserved.</p>
        </div>
        <div className="common-footer-logo">
          <div className='common-content'>
            <div className='common-content-title'>联系我们</div>
          <p className='common-connection'>邮箱：<a className='common-link' href="mailto:westlakelab@westlake.edu.cn">westlakelab@westlake.edu.cn</a></p>
          <p className='common-connection'>电话：0571-87089787</p>
          <p className='common-connection'>邮编：310024</p>
          <p className='common-connection'>地址：浙江省杭州市西湖区石龙山街18号</p>
          </div>
        </div>
        <div className="common-footer-logo">
        <div className='common-content'>
        <div className='common-content-title'>相关链接</div>
        <div className='common-link' onClick={()=>{
           window.open('https://en.wllsb.edu.cn/', '_blank');
        }}>Westlake Laboratory</div>
          <div className='common-link' onClick={()=>{
           window.open('https://yanglab.westlake.edu.cn/', '_blank');
        }}>Yang Lab</div>
          <div className='common-link' onClick={()=>{
           window.open('https://wekwikgene.wllsb.edu.cn/', '_blank');
        }}>WeKwikGene</div>
          </div>
        </div>
        <div className="common-footer-logo">
        <div className='common-content' style={{marginTop:58}}>
        
        <img src="/assets/images/wechat.png" alt="LOGO"  className='code-img'/>
          <p style={{textAlign:'center'}}>FOLLOW US</p>
          </div>
        </div>
        </div>
        <div className="common-footer-bottom"></div>
      </div>
    );
  }
}

export default Footer;
